import './App.css';

function About() {
  return (
    <div className="Container">
        {/* New markup. Hidden in legacy mode by ai.css so the original renders unchanged. */}
        <header className="page-head">
          <h1 className="page-title">about me</h1>
        </header>
        {/* Same polaroid device as Home. In legacy the figure is display:contents
            and the caption is hidden, so the original page renders unchanged. */}
        <figure className="polaroid hero-polaroid">
          <img className="Pic" src={process.env.PUBLIC_URL + '/Unhooded-KennyMcCormick.webp'} alt="moustache!" />
          <figcaption>Unhooded-KennyMcCormick.webp</figcaption>
        </figure>

        <div className="Blurb">
        <p>techology i'm familiar with... there's more even!</p>  
          <ul>
            <li>database administration (sql server, mongo, oracle)</li>
            <li>automation scripting (powershell, node, python)</li>
            <li>aws and terraform (s3, ecs, eventbridge, step functions, secret vaults, etc)</li>
            <li>data engineering (sql, python, node, experienced with big data and pipeline builds)</li>
            <li>react (jsx, html, css (ugh..), bootstrap, stylized compontents,hooks)</li>
            <li>integrations (rest api, mqtt, sftp, etl)</li>
          </ul>
        <p>other cool stuff i enjoy</p>
        <ul>
            <li>lowkey games like animal crossing</li>
            <li>music</li>
            <li>gardening</li>
            <li>my little dudes :D </li>
          </ul>
        </div>
      </div>
  );
}

export default About;